import Icon from '../Icon.jsx';
import { ArrowLink, BROOK, BedMapsIcon, ButtonLink, Check, ClosingBand, HART, PageLabel, PhoneMyRepairs, QuoteCard, RequestBar } from '../parts.jsx';
import { appLinks } from '../navigation.js';

const portalSteps = ['Report the repair in the app.', 'Your housing team gets it in BedMaps.', 'Track the repair until it is fixed.'];
const beforeYouChoose = ['Their company details', 'Where they are based', 'When they can come', 'Their price, before you book'];

function OrganisationCard({ icon, label, title, text, eventIcon, eventTitle, eventPlace, eventAction, to }) {
  return <article className="mk-org-card">
    <span className="mk-icon-tile is-56"><Icon name={icon} size={28}/></span>
    <p className="mk-card-label">{label}</p>
    <h3 className="mk-h3 is-28">{title}</h3>
    <p className="mk-body">{text}</p>
    <div className="mk-event">
      <Icon name={eventIcon} size={22}/>
      <div className="mk-event-text"><p className="mk-event-title">{eventTitle}</p><p className="mk-event-place">{eventPlace}</p></div>
      <span className="mk-event-action">{eventAction}</span>
    </div>
    <ArrowLink to={to}>{label}</ArrowLink>
  </article>;
}

export default function HomePage() {
  return <>
    <section className="mk-container mk-hero" aria-labelledby="home-title">
      <div className="mk-hero-copy">
        <h1 className="mk-display is-60" id="home-title">Book a repair.<br/>Choose who comes.</h1>
        <p className="mk-lead">Take a photo of the problem and we will find local, checked tradespeople to quote. You choose who comes, and when.</p>
        <RequestBar/>
        <div className="mk-checks"><Check>Checked local tradespeople</Check><Check>Nothing is booked until you choose</Check></div>
      </div>
      <div className="mk-hero-visual is-phone"><PhoneMyRepairs/></div>
    </section>

    <section className="mk-container mk-section is-after-hero" aria-labelledby="pillars-title">
      <h2 className="mk-h2" id="pillars-title">Repairs and housing support</h2>
      <div className="mk-bento">
        <div className="mk-pillar is-repair">
          <div className="mk-pillar-copy">
            <PageLabel icon="wrench">Home &amp; Services</PageLabel>
            <div className="mk-pillar-text">
              <h3 className="mk-h3 is-32">Book a Repair</h3>
              <p className="mk-body">Compare prices and times. Choose who comes.</p>
            </div>
            <ArrowLink to="/home-services">Book a repair</ArrowLink>
          </div>
          <div className="mk-pillar-quotes"><QuoteCard {...BROOK}/><QuoteCard {...HART}/></div>
        </div>
        <div className="mk-pillar is-passport">
          <div className="mk-pillar-text">
            <PageLabel icon="house">Self refer</PageLabel>
            <h3 className="mk-h3 is-28">Looking for a home?</h3>
            <p className="mk-body">Tell us where you’d like to live and what support you need. No account or documents needed to enquire.</p>
          </div>
          <ButtonLink to="/enquire" className="mk-self-referral-cta">Self Referral<Icon name="arrow-right" size={18}/></ButtonLink>
        </div>
      </div>
    </section>

    <section className="mk-band is-white" aria-labelledby="check-title">
      <div className="mk-container mk-split is-centred">
        <div className="mk-split-copy is-560">
          <h2 className="mk-h2 is-40" id="check-title">Check Before You Book</h2>
          <p className="mk-body">Every tradesperson shows their checks before you book.</p>
        </div>
        <div className="mk-checks-card">
          <p className="mk-checks-card-intro">Before you choose, you can see:</p>
          <ul className="mk-tick-list">{beforeYouChoose.map((item) => <li key={item}><Icon name="check" size={20}/>{item}</li>)}</ul>
        </div>
      </div>
    </section>

    <section className="mk-band is-wash" aria-labelledby="landlord-title">
      <div className="mk-container mk-split">
        <div className="mk-split-copy is-520">
          <p className="mk-bedmaps-label"><BedMapsIcon size={32}/>Works with BedMaps</p>
          <h2 className="mk-h2" id="landlord-title">Report a Repair<br/>to Your Landlord</h2>
          <p className="mk-body">Add their repair contact and we send it for you. Or choose never to contact them.</p>
        </div>
        <div className="mk-portal">
          <ol className="mk-portal-steps">{portalSteps.map((step, index) => <li key={step}><span className="mk-portal-number">{String(index + 1).padStart(2, '0')}</span>{step}</li>)}</ol>
          <p className="mk-portal-note">Is your housing provider on BedMaps? Your repairs go straight to them.</p>
        </div>
      </div>
    </section>

    <section className="mk-container mk-section" aria-labelledby="organisations-title">
      <h2 className="mk-h2 is-640" id="organisations-title">For Businesses and Housing Providers</h2>
      <div className="mk-org-cards">
        <OrganisationCard icon="store" label="For Businesses" title="Find Repair Jobs Near You" text="Receive requests. Send quotes. Win work. No commission on jobs."
          eventIcon="map-pin" eventTitle="New job near you: dripping kitchen tap" eventPlace="Birmingham, B6 · 2 photos" eventAction="Send quote" to="/for-businesses"/>
        <OrganisationCard icon="building-2" label="For Housing Providers" title="Get Repair Requests from Residents" text="Residents report repairs with a photo. We send them to your repairs team. BedMaps providers get them in BedMaps."
          eventIcon="inbox" eventTitle="New repair request: dripping kitchen tap" eventPlace="Birmingham, B6 · 1 photo" eventAction="View" to="/for-housing-providers"/>
      </div>
    </section>

    <ClosingBand title="Get Started" text="Take a photo. Get quotes from checked local tradespeople.">
      <ButtonLink to={appLinks.createAccount} variant="white">Create an account</ButtonLink>
      <ButtonLink to="/how-it-works" variant="glass">How it works</ButtonLink>
    </ClosingBand>
  </>;
}
